import {
  CcfAgentFilterIcon,
  CcfBox,
  CcfNavigateToSimulatorIcon,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import styles from './ccf-wem-dashboard.module.scss';
import { DataGrid } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { evaluationsData } from './evalutionMockData';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import { makeStyles } from '@mui/styles';

/* eslint-disable-next-line */
export interface CcfWemEvaluationsProps {}

const useStyles = makeStyles({
  root: {
    '& .MuiDataGrid-root': {
      border: '1px solid rgba(251, 252, 252, 1)',
      Height: '330px',
    },

    '& .MuiDataGrid-columnHeaderTitleContainer': {
      padding: '0px',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '16px',
      textTransform: 'uppercase',
      color: '#526B79',
    },
    '& .MuiDataGrid-columnsContainer': {
      background: '#FFFFF',
      border: '1px solid #D2D8DB',
      boxShadow: '0px 3px 4px rgba(0, 0, 0, 0.08)',
    },
    '& .styledrows': {
      height: '36px',
      background: '#FFFFF',
      border: '1px solid #D2D8DB',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '13px',
      lineHeight: '18px',

      color: '#333333',

      /* Inside auto layout */
    },
    // '& .MuiDataGrid-window': {
    //   height: '285px',
    //   overflowY: 'scroll',
    // },
  },
  searchInput: {
    '&.MuiOutlinedInput-input': {
      padding: '5px',
    },
    // '&.MuiOutlinedInput-inputAdornedEnd': {
    //   paddingBottom: '7.5px',
    // },
  },
});
/**
 * Function to handle drawer open close
 * @example renderIconForType()
 */
const renderIconForType = (param: string) => {
  switch (param) {
    case 'voice':
      return <PhoneInTalkIcon style={{ fill: '#7D3CC8' }} />;
    case 'chat':
      return (
        <CcfBox>
          <img src={'/assets/typechat.png'} alt={'typechat'} />
        </CcfBox>
      );
    default:
      return '';
  }
};

/**
 * CcfWemEvaluations - used to display wem evaluations
 * @param props - CcfWemEvaluations
 * @example `<CcfWemEvaluations />`
 */
export function CcfWemEvaluations(props: CcfWemEvaluationsProps) {
  const classes = useStyles();
  const [rowData, setRowData]: any = useState([]);
  const columns = [
    {
      field: 'type',
      headerName: 'type'.toUpperCase(),
      width: 60,
      headerClassName: 'gridHeaderText',
      renderCell: (params: any) => {
        const iconType =
          params.value === 'voice' && params.row.voiceDirection === 'inbound'
            ? 'inbound'
            : params.value === 'voice' &&
              params.row.voiceDirection === 'outbound'
            ? 'outbound'
            : params.value;

        return renderIconForType(iconType);
      },
    },
    {
      field: 'evaluationsType',
      headerName: 'evaluation type'.toUpperCase(),
      width: 120,
    },
    {
      field: 'formName',
      headerName: 'form name'.toUpperCase(),
      width: 100,
    },
    {
      field: 'interactionDate',
      headerName: 'interaction date'.toUpperCase(),
      width: 190,
    },
    {
      field: 'duration',
      headerName: 'duration'.toUpperCase(),
      width: 100,
    },
    {
      field: 'remainingDays',
      headerName: 'remaining days'.toUpperCase(),
      width: 100,
    },

    {
      field: 'evaluationSubject',
      headerName: 'evaluation subject'.toUpperCase(),
      width: 120,
    },
    {
      field: 'evaluatedOn',
      headerName: 'evaluated on'.toUpperCase(),
      width: 120,
    },
    {
      field: 'score',
      headerName: 'score'.toUpperCase(),
      width: 100,
    },
    {
      field: 'status',
      headerName: 'status'.toUpperCase(),
      width: 120,
      renderCell: (params: any) => {
        return (
          <CcfBox style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            {' '}
            <CheckCircleOutlineOutlinedIcon
              htmlColor={'#39C44A'}
              style={{ width: '20px' }}
            />
            {params.value}{' '}
          </CcfBox>
        );
      },
    },
    {
      field: '',
      headerName: '',
      width: 80,
      renderCell: (params: any) => {
        return (
          <CcfBox style={{ display: 'flex', alignItems: 'center' }}>
            <CcfNavigateToSimulatorIcon fillColor="#526b7a" />
          </CcfBox>
        );
      },
    },
  ];
  useEffect(() => {
    const rd = evaluationsData.map((x, i) => {
      return {
        id: i,
        type: x.type,
        interactionDate: x.interactionDate,
        status: x.status,
        formName: `${x.formName}`,
        evaluationsType: x.evaluationsType,
        evaluationSubject: x.evaluationSubject,
        evaluatedOn: x.evaluatedOn,
        score: x.score,
        duration: x.duration,
        remainingDays: x.remainingDays,
      };
    });

    setRowData(rd);
  }, []);
  return (
    <CcfBox className={styles.wemScheduleContainer}>
      <CcfBox>
        <CcfTypography className={styles.wemTabTitle}>
          Evaluations
        </CcfTypography>
      </CcfBox>
      <CcfBox className={styles.searchBar}>
        <CcfBox className={styles.searchCountText}>2 evaluations</CcfBox>
        <CcfBox className={styles.filterIconBlock}>
          <CcfAgentFilterIcon style={{ fontSize: 16 }} />
        </CcfBox>
      </CcfBox>

      <CcfBox
        style={{
          height: '100%',
          backgroundColor: '#f2f7fa',
          overflowY: 'hidden',
          borderTop: '1px solid #E1E1E1',
        }}
        id={`agent_wem_evaluation_dataGridContainer`}
      >
        <DataGrid
          classes={{ root: classes.root }}
          rows={rowData}
          columns={columns}
          rowHeight={40}
          getRowId={(row) => row?.id}
          pageSize={10}
          headerHeight={40}
          // autoHeight
          disableSelectionOnClick
          pagination
          rowsPerPageOptions={[5, 10, 25]}
          getRowClassName={(params: any) => `styledrows`}
          sx={{
            '& .MuiDataGrid-columnHeaderTitle': {
              color: '#3F5C69',
              fontWeight: '600',
              fontSize: '12px',
              fontFamily: 'Open Sans',
            },
          }}
        />
      </CcfBox>
    </CcfBox>
  );
}
